import { render } from "./UserEducationRecord.vue?vue&type=template&id=525f6de9&scoped=true"
import script from "./UserEducationRecord.vue?vue&type=script&lang=js"
export * from "./UserEducationRecord.vue?vue&type=script&lang=js"

import "./UserEducationRecord.vue?vue&type=style&index=0&id=525f6de9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525f6de9"]])

export default __exports__